module.exports = __webpack_public_path__ + "img/transinactive.be011ee1.svg";